import { DetailsTabMenu } from '@/components/details';
import { tourRoute } from '@/features/dashboard/tours/routes/tourRoute.ts';
import { tourTabLinks } from '@/features/dashboard/tours/routes/tourTabs.ts';

/** Goły adres wyjazdu: menu kafli na telefonie, „Podsumowanie” szeroko. */
const TourTabMenu = () => {
  const { tourId } = tourRoute.useParams();

  return <DetailsTabMenu tabs={tourTabLinks(tourId)} />;
};

export default TourTabMenu;
